module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-number/spk-number.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-number/spk-number.component.scss
// module chunks = main